import React, { useEffect, useState } from "react";
import styles from "./news.module.css";
import { Link, useLocation } from "react-router-dom";
import { setMetaTags, getDataFromRoutes } from "../../utils/util_functions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { useDispatch, useSelector } from "react-redux";
import { getNews, getLoading, getRoutes } from "../../services/selectors";
import Loader from "../../components/loader/loader";
import { ROUTES_CONST } from "../../utils/constants";
import { getListNewsThunk } from "../../services/actions/news_actions";
import Paginator from "../../components/paginator/paginator";
import image from "../../images/news_preview.png";
import news_image_default from "../../images/news_image_default.png";


const News = () => {

  const newsType = {
    NEWS: "news",
    ARTICLES: "articles",
    ALL: "all"
  }

  const [type, setType] = useState(newsType.ALL);
  const [page, setPage] = useState(1);
  const location = useLocation();
  const isLoading = useSelector(getLoading);
  const routes = useSelector(getRoutes);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  const news = useSelector(getNews);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {window.scrollTo({ top: 0, left: 0 })}, []);

  const handleChangeType = (e) => {
    setType(e.target.value);
    dispatch(getListNewsThunk(e.target.value, 1, routes));
  }

  useEffect(() => {
    setPage(1);
  }, [type]);

  useEffect(() => {
    dispatch(getListNewsThunk(type, page, routes));
    // eslint-disable-next-line
  }, [page]);

  const defaultImageHandler = (e) => {
    e.target.src = news_image_default;
  }



  return (
    <main className='main'>
      <h1 className="title">{title}</h1>
      {isLoading ? <Loader /> : null}
      {news.news.length > 0 ?
        <>
          {
            <div className={styles.radioContainer}>
              <label
                htmlFor="type_all"
                className={type === newsType.ALL ? styles.radioLabel__checked : styles.radioLabel}
              >
                все публикации
                <input
                  type="radio"
                  name="type_all"
                  id="type_all"
                  className={styles.radioInput}
                  value={newsType.ALL}
                  checked={type === newsType.ALL}
                  onChange={handleChangeType}
                />
              </label>
              <label
                htmlFor="type_news"
                className={type === newsType.NEWS ? styles.radioLabel__checked : styles.radioLabel}
              >
                только новости
                <input
                  type="radio"
                  name="type_news"
                  id="type_news"
                  className={styles.radioInput}
                  value={newsType.NEWS}
                  checked={type === newsType.NEWS}
                  onChange={handleChangeType}
                />
              </label>
              <label
                htmlFor="type_articles"
                className={type === newsType.ARTICLES ? styles.radioLabel__checked : styles.radioLabel}
              >
                только статьи
                <input
                  type="radio"
                  name="type_articles"
                  id="type_articles"
                  className={styles.radioInput}
                  value={newsType.ARTICLES}
                  checked={type === newsType.ARTICLES}
                  onChange={handleChangeType}
                />
              </label>
            </div>
          }
          <ul className={styles.list}>
            {news.news.map(item =>
              <li key={item.id}>
                <Link to={`/news/${item.slug}`} className={styles.container}>
                  <img
                    src={item.preview ? item.preview : image}
                    alt="изображение для новости" className={styles.preview}
                    onError={defaultImageHandler}
                  />
                  <div className={styles.textContent}>
                    <span className={styles.info}>
                      {item.news ? 'Новость' : 'Статья'} от {item.created_date} года
                    </span>
                    {item.name}
                    <span className={styles.trailer}>
                      {item.trailer}
                    </span>
                    <p className={styles.details}>Читать &raquo;</p>
                  </div>
                </Link>
              </li>
            )}
          </ul>
          {news.pages > 1 &&
            <div className={styles.paginatorWrapper}>
              <Paginator
                page={page}
                setPage={setPage}
                pages={news.pages}
              />
            </div>
          }
        </> :
        <p className={styles.text}>Новости скоро появятся.</p>
      }
    </main>
  );
};

export default News;
